import React from 'react'
import { useTheme } from 'styled-components'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import Figure from 'react-bootstrap/Figure'
import getThemeValue from '../../utils/getThemeValue'
import SafelySetInnerHTML from '../SafelySetInnerHTML'
import { useLocation } from 'react-router'

const InfographWrapper = styled.div`
  margin: 3rem 0;
  justify-content: center;
`

const ContactWrappedStyled = styled.div`
  width: 100%;
  margin: 3rem 0;
  text-align: center;
  p {
    margin: 0px;
  }
  .red-bold {
    color: #eb0045;
    font-weight: bold;
  }
`

const InfographItemWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 1200px) {
    margin-top: 0;
  }

  @media screen and (min-width: 992px) {
    flex-direction: row;
  }
`
const InfographItem = styled.div`
  border-left: 0;
  padding: 0 2rem;
  margin: 0 0 1rem;
  @media screen and (min-width: 992px) {
    border-left: 1px solid #ccc;
  }
  .figure-img {
    max-width: 4.5rem;
    margin-right: 1rem;
  }
  &:first-child {
    border-left: 0;
  }
`

const StyledFigure = styled(Figure)`
  display: flex;
  align-items: flex-start;
  margin: 0px;
`
const ContactInfos = () => {
  const mandate = process.env.REACT_APP_MANDATORSET

  const { t } = useTranslation()
  const theme = useTheme()
  let location = useLocation()
  const pathname = location.pathname
  const isPasswordResetPage = pathname === '/password-reset'
  const isLoginPage = pathname === '/login'
  const isSignUpPage = pathname === '/sign-up'
  const workingWeekHours = getThemeValue('contactInfos', 'workingWeekHours', '')
  const workingWeekendHours = getThemeValue(
    'contactInfos',
    'workingWeekendHours',
    ''
  )
  return (
    <>
      <ContactWrappedStyled>
        <div>
          {mandate === 'cws' && isPasswordResetPage && (
            <SafelySetInnerHTML>
              {getThemeValue(
                'contactInfos',
                'contactInfosHeadline1',
                t('loginBox:cwsMessage1Line1')
              )}
            </SafelySetInnerHTML>
          )}

          {/* Check if mandate is 'cws' and the page is '/login' */}
          {mandate === 'cws' && isLoginPage && (
            <SafelySetInnerHTML>
              {getThemeValue('contactInfos', 'loginPageCWS')}
            </SafelySetInnerHTML>
          )}

          {/* Check if mandate is 'cws' and the page is '/sign-up' */}
          {mandate === 'cws' && isSignUpPage && (
            <SafelySetInnerHTML>
              {getThemeValue('contactInfos', 'loginPageCWS')}
            </SafelySetInnerHTML>
          )}
        </div>
        <div>
          {mandate !== 'cws' && (
            <>
              <SafelySetInnerHTML>
                {getThemeValue(
                  'contactInfos',
                  'contactInfosHeadline1',
                  t('loginBox:message1')
                )}
              </SafelySetInnerHTML>
              <SafelySetInnerHTML>
                {getThemeValue(
                  'contactInfos',
                  'contactInfosHeadline2',
                  t('loginBox:message2')
                )}
              </SafelySetInnerHTML>
            </>
          )}
          {mandate === 'cws' && (
            <div className='red-bold'>
              <SafelySetInnerHTML>
                {getThemeValue('contactInfos', 'contactInfosHeadline3')}
              </SafelySetInnerHTML>
            </div>
          )}
        </div>
      </ContactWrappedStyled>
      <InfographWrapper className='d-flex contact-piqo'>
        <InfographItemWrapper>
          {theme.contactInfos.phoneContact ? (
            <InfographItem>
              <StyledFigure>
                <Figure.Image
                  width={40}
                  height={40}
                  alt='40x40'
                  src={
                    theme.userLogin.phoneIcon ? theme.userLogin.phoneIcon : ''
                  }
                />
                <Figure.Caption>
                  <h3>{t('loginBox:phone')} </h3>
                  <p>
                    <a
                      className='text-secondary'
                      href={`tel:${theme.contactInfos.phoneContact}`}
                    >
                      {theme.contactInfos.phoneContact}
                    </a>
                  </p>
                </Figure.Caption>
              </StyledFigure>
            </InfographItem>
          ) : null}
          {theme.contactInfos.emailContact ? (
            <InfographItem>
              <StyledFigure>
                <Figure.Image
                  width={40}
                  height={40}
                  alt='40x40'
                  src={theme.userLogin.mailIcon ? theme.userLogin.mailIcon : ''}
                />
                <Figure.Caption>
                  <h3>{t('loginBox:email')} </h3>
                  <p>
                    {mandate === 'cws' && isPasswordResetPage && (
                      <a
                        className='text-secondary'
                        href={`mailto:${theme.contactInfos.emailForgetPass}`}
                      >
                        {theme.contactInfos.emailForgetPass}
                      </a>
                    )}
                    {mandate === 'cws' && isLoginPage && (
                      <a
                        className='text-secondary'
                        href={`mailto:${theme.contactInfos.emailContact}`}
                      >
                        {theme.contactInfos.emailContact}
                      </a>
                    )}
                    {mandate === 'cws' && isSignUpPage && (
                      <a
                        className='text-secondary'
                        href={`mailto:${theme.contactInfos.signUpEmail}`}
                      >
                        {theme.contactInfos.signUpEmail}
                      </a>
                    )}
                    {mandate !== 'cws' && (
                      <a
                        className='text-secondary'
                        href={`mailto:${theme.contactInfos.emailContact}`}
                      >
                        {theme.contactInfos.emailContact}
                      </a>
                    )}
                  </p>
                </Figure.Caption>
              </StyledFigure>
            </InfographItem>
          ) : null}

          {workingWeekHours || workingWeekendHours ? (
            <InfographItem>
              <StyledFigure>
                <Figure.Image
                  width={40}
                  height={40}
                  alt='40x40'
                  src={
                    theme.userLogin.contactIcon
                      ? theme.userLogin.contactIcon
                      : ''
                  }
                />
                <Figure.Caption>
                  <h3>{t('loginBox:contactTimes')} </h3>

                  {workingWeekHours ? (
                    <div className='text-secondary'>{workingWeekHours}</div>
                  ) : null}

                  {workingWeekendHours ? (
                    <div className='text-secondary'>{workingWeekendHours}</div>
                  ) : null}
                </Figure.Caption>
              </StyledFigure>
            </InfographItem>
          ) : null}
        </InfographItemWrapper>
      </InfographWrapper>
    </>
  )
}

export default ContactInfos
